// @ts-nocheck

import { NetworkActionTypes } from '../types/actions/network';

// Actions
export const connect = { type: NetworkActionTypes.CONNECT };
export const reconnect = { type: NetworkActionTypes.RECONNECT };
export const connected = { type: NetworkActionTypes.CONNECTED };
export const disconnected = { type: NetworkActionTypes.DISCONNECTED };
export const close = { type: NetworkActionTypes.CLOSE };
export const send = (payload, meta = {}) => ({ type: NetworkActionTypes.SEND, payload, meta });
export const recv = (payload) => ({ type: NetworkActionTypes.RECV, payload });

export default {
  connect,
  reconnect,
  connected,
  disconnected,
  close,
  send,
  recv,
};
